import * as React from 'react';

type ICustomizeColumnsModalContext = {
    isCustomizeColumnsModalOpen: boolean;
    setIsCustomizeColumnsModalOpen: (open: boolean) => void;
};

const defaultCustomizeColumnsStore: ICustomizeColumnsModalContext = {
    isCustomizeColumnsModalOpen: false,
    setIsCustomizeColumnsModalOpen: () => {},
};

const CustomizeColumnsContext = React.createContext<ICustomizeColumnsModalContext>(defaultCustomizeColumnsStore);

export const useCustomizationModalColumns = (): ICustomizeColumnsModalContext => {
    return React.useContext(CustomizeColumnsContext);
};

export const CustomizeColumnsModalProvider = ({ children }: any) => {
    const [isCustomizeColumnsModalOpen, setIsCustomizeColumnsModalOpen] = React.useState(false);
    return (
        <CustomizeColumnsContext.Provider value={{ isCustomizeColumnsModalOpen, setIsCustomizeColumnsModalOpen }}>
            {children}
        </CustomizeColumnsContext.Provider>
    );
};
